import React from 'react'
import { COLUMN_TYPES, Icon, reducers } from '@adc/ui-morpheus'
import { TINY_URLS } from '../../constants/tableTypes'

const getDefaultProps = width => ({
  width,
  isResizable: true,
  isReorderable: true,
  isVisible: true,
})

export const tableConfig = {
  config: {
    entityKey: TINY_URLS,
    primaryKeyField: 'id',
  },
  fieldDefinitions: [
    {
      name: 'Tiny URL',
      apiRef: 'tiny_url',
      columnDefinition: {
        type: COLUMN_TYPES.TEXT,
        partialMatch: true,
        colProps: {
          ...getDefaultProps(200),
          searchable: true,
        },
      },
    },
    {
      name: 'Full URL',
      apiRef: 'full_url',
      columnDefinition: {
        type: COLUMN_TYPES.TEXT,
        partialMatch: true,
        colProps: {
          ...getDefaultProps(300),
          searchable: true,
        },
      },
    },
    {
      name: 'Description',
      apiRef: 'description',
      columnDefinition: {
        type: COLUMN_TYPES.TEXT,
        colProps: { ...getDefaultProps(300), searchable: true },
      },
    },
    {
      name: 'Created Date',
      apiRef: 'created_date',
      columnDefinition: {
        type: COLUMN_TYPES.DATE,
        colProps: { ...getDefaultProps(50), searchable: true },
      },
    },
    {
      name: 'Updated Date',
      apiRef: 'updated_date',
      columnDefinition: {
        type: COLUMN_TYPES.DATE,
        colProps: { ...getDefaultProps(50), searchable: true },
      },
    },
    {
      name: 'Click Count',
      apiRef: 'click_count',
      columnDefinition: {
        type: COLUMN_TYPES.TEXT,
        colProps: { ...getDefaultProps(50), searchable: true },
      },
    },
    {
      name: 'Edit',
      apiRef: '__actions__', // not api val
      columnDefinition: {
        type: COLUMN_TYPES.ACTION,
        actions: ['Link'],
        colProps: { width: 50, fixedRight: true, align: 'center' },
      },
    },
  ],
  filterClauses: [],
}

const columnAction =
  actionCellActionType =>
  (actionIndex, rowIndex, primaryId, data, onRowAction) =>
    (
      <Icon
        color='info'
        size='large'
        style={{ marginTop: -3, cursor: 'pointer' }}
        name='write square'
        key={actionIndex}
        title='View Details'
        data-elm-id={`action_edit_${rowIndex}`}
        onClick={() => onRowAction(actionCellActionType, rowIndex, primaryId)}
      />
    )

/**
 *
 * @param {*} fieldDefinitions
 * THIS SELECTOR IS TO MAINTAIN BACKWARDS COMPATIBILITY WITH EVERYTHING IN TOOLKIT
 * It will change/ be removed when everything there changes. This is so we can refactor slowly
 */
export const columnSelector = state =>
  state.fieldDefinitions
    .filter(field => field.columnDefinition)
    .map(col => {
      const column = {
        ...col.columnDefinition,
        ...{ field: col.apiRef, title: col.name },
      }
      if (column.actions) column.actions = column.actions.map(columnAction)
      return column
    })

export const getFilterClauses = state => state.filterClauses

export default reducers.dataTable.dataTable(TINY_URLS, tableConfig)
